<template>
  <form class="question-form">
    <div class="answer-options">
      <label
          v-for="answerOption in question[question.perspective].answerOptions"
          :key="answerOption.id"
          class="checkbox"
      >
        {{ answerOption.text }}
        <input
            v-model="answerOptions"
            :value="answerOption.id"
            type="checkbox"
        />
        <span class="checkmark"></span>
      </label>
    </div>
  </form>
</template>

<script>
export default {
  name: "MultipleChoice",
  props: {
    question: {
      required: true,
      type: Object,
      validator: (value) => {
        return value[value.perspective].type === 'MultipleChoice'
            && value[value.perspective].answerOptions.length > 0
            ;
      }
    }
  },
  data() {
    return {
      answerOptions: []
    }
  },
  methods: {
    validateAnswer() {
      let answers = [];
      let correct = this.answerOptions.length !== 0;
      this.answerOptions.forEach(value => {
        this.question[this.question.perspective].answerOptions.forEach(
            option => {
              if (option.id === value) {
                answers.push(option);
                if (!option.isCorrectAnswer) {
                  correct = false;
                }
              }
            }
        );
      });

      return {
        correct: correct,
        missed: false,
        //answers: answers
      }
    }
  }
}
</script>

<style lang="scss" scoped>

$vhUnit: 9;
$vwUnit: 16;
$vhUnitMobile: 3.75;
$vwUnitMobile: 6.66;

@function scaleVh($size) {
  @return #{($size/$vhUnit)}vh;
}
@function scaleVw($size) {
  @return #{($size/$vwUnit)}vw;
}
@function scaleMobileVh($size) {
  @return #{($size/$vhUnitMobile)}vh;
}
@function scaleMobileVw($size) {
  @return #{($size/$vwUnitMobile)}vw;
}

label {

}

.checkbox {
  display: block;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  border: 2px solid rgb(166, 207, 183);
}

/* On mouse-over, add a grey background color */
.checkbox:hover input ~ .checkmark {
  background-color: rgb(166, 207, 183);
}

/* When the checkbox is checked, add a blue background */
.checkbox input:checked ~ .checkmark {
  border: 2px solid rgb(255, 255, 255);
  box-shadow: 0 0 0.5em 0 rgba(255, 255, 255, 0.5);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox .checkmark:after {
  border: solid #b9d400;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  border-width: 0 4px 4px 0;
}

@media(min-aspect-ratio: 16/9) {

  .checkbox .checkmark:after {
    /*filter: blur(scaleVh(0.7));*/
    border-width: 0 scaleVh(7) scaleVh(7) 0;
  }

  .checkbox {
    padding-left: scaleVh(30 + 28);
    margin-bottom: scaleVh(30);
  }

  .checkmark {
    width: scaleVh(28);
    height: scaleVh(28);
    border-radius: scaleVh(4);
  }

  .checkbox .checkmark:after {
    left: 0;
    top: scaleVh(-21);
    width: scaleVh(16);
    height: scaleVh(32);
  }

  label {
    padding-top: scaleVh(4);
    margin-bottom: scaleVh(30);
  }

  // mobile -----
  .mobile {
    .checkbox {
      padding-left: scaleMobileVh(20 + 24);
      margin-bottom: scaleMobileVh(20);
    }
    .checkmark {
      width: scaleMobileVh(24);
      height: scaleMobileVh(24);
      border-radius: scaleMobileVh(4);
    }
    .checkbox .checkmark:after {
      left: scaleMobileVh(3);
      top: scaleMobileVh(-10);
      width: scaleMobileVh(12);
      height: scaleMobileVh(24);
    }
    label {
      padding-top: scaleMobileVh(4);
      margin-bottom: scaleMobileVh(10);
    }
  }

}

@media(max-aspect-ratio: 16/9) {
  .checkbox .checkmark:after {
    /*filter: blur(scaleVw(0.7));*/
    border-width: 0 scaleVw(7) scaleVw(7) 0;
  }
  .checkbox {
    padding-left: scaleVw(30 + 28);
    margin-bottom: scaleVw(30);
  }

  .checkmark {
    width: scaleVw(28);
    height: scaleVw(28);
    border-radius: scaleVw(4);
  }

  .checkbox .checkmark:after {
    left: 0;
    top: scaleVw(-22);
    width: scaleVw(16);
    height: scaleVw(32);
  }

  label {
    padding-top: scaleVw(4);
    margin-bottom: scaleVw(30);
  }

  .mobile {
    .checkbox {
      padding-left: scaleMobileVw(20 + 24);
      margin-bottom: scaleMobileVw(20);
    }
    .checkmark {
      width: scaleMobileVw(24);
      height: scaleMobileVw(24);
      border-radius: scaleMobileVw(4);
    }
    .checkbox .checkmark:after {
      left: scaleMobileVw(3);
      top: scaleMobileVw(-10);
      width: scaleMobileVw(12);
      height: scaleMobileVw(24);
    }
    label {
      padding-top: scaleMobileVw(4);
      margin-bottom: scaleMobileVw(10);
    }
  }
}


</style>